import { useState } from 'react';
import { Container, Heading, FormControl, FormLabel, Input, Textarea, Select, Button } from '@chakra-ui/react';
import Layout from './layouts/main';
import Section from './section';
import styles from "../../styles/components/contact.module.css"
import Head from 'next/head';
import Link from 'next/link';

const Posts = () => {
  const [name, setName] = useState('');
  const [reason, setReason] = useState('');
  const [category, setCategory] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      name,
      reason,
      category,
      message
    };

    fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => alert(result.message))
      .catch((error) => alert(error.message));
  };




  return (

    <>
      <Head>
        <Link rel="stylesheet" href={"/styles/components/contact.module.css"} />
      </Head>
      <div className={styles.contact_whole}>
        <Layout className={styles.contact_whole_wrapper}>
          <Container >
            <Heading as="h3" fontSize={20} mb={4}>
              Contact Me
            </Heading>
            <Section delay={0.1}>

              <h1 className={styles.email}>
                Deo_singiza@hotmail.com
              </h1>

              <h1 className={styles.number}>
                519-965-9128
              </h1>
            </Section>
          </Container>
        </Layout>
      </div>
    </>
  );
};

export default Posts;
